<template>
  <div class="d-flex">
    <v-btn
      v-bind="$attrs"
      v-on="$listeners"
      class="
        px-9
        font-weight-bold
        text-none text-body-1
        primary--text
        button-widget
      "
      :color="!secondary ? 'secondary' : 'white'"
      :height="big ? '56px' : '48px'"
      depressed
      tile
    >
      <slot />
    </v-btn>
  </div>
</template>

<script>
export default {
  props: {
    secondary: {
      type: Boolean,
      default: false,
    },
    big: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
.button-widget {
  letter-spacing: 0.1em !important;
}
</style>
